module.exports = " <div class=info _v-69eedc30=\"\"> <title-bar title=详细资料 _v-69eedc30=\"\"></title-bar> <router-view _v-69eedc30=\"\"></router-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-69eedc30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/Info.vue
 ** module id = 353
 ** module chunks = 2
 **/